var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHatena(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B3\\u30F3\\u30DD\\u30FC\\u30CD\\u30F3\\u30C8_92_9",
    "data-name": "\\u30B3\\u30F3\\u30DD\\u30FC\\u30CD\\u30F3\\u30C8 92 \\u2013 9",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1515",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1515",
    transform: "translate(-176 -1859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9577\\u65B9\\u5F62_13349",
    "data-name": "\\u9577\\u65B9\\u5F62 13349",
    transform: "translate(176 1860)",
    fill: "#41619a",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1444",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1444",
    transform: "translate(83.725 1543.673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1517",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1517",
    transform: "translate(2.389 -8.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_222",
    "data-name": "\\u30D1\\u30B9 222",
    d: "M105.887,328.094A11.826,11.826,0,1,1,94.061,339.92a11.839,11.839,0,0,1,11.826-11.826m0-4.174a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z",
    fill: "#41619a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_223",
    "data-name": "\\u30D1\\u30B9 223",
    d: "M106.257,332.258a5.438,5.438,0,0,0-3.662,1.323,5.575,5.575,0,0,0-1.7,3.8l-.021.223,2.9.613.036-.268c.245-1.844,1.007-2.741,2.332-2.741a1.875,1.875,0,0,1,1.361.492,1.736,1.736,0,0,1,.512,1.335,2.889,2.889,0,0,1-1.409,2.2,6.85,6.85,0,0,0-1.331,1.206,2.118,2.118,0,0,0-.339,1.257v2.455h2.73l0-.248a15.038,15.038,0,0,1,.109-1.951,1.22,1.22,0,0,1,.455-.478,15.051,15.051,0,0,0,1.7-1.4l.138-.129a4.4,4.4,0,0,0,1.28-3.054,4.077,4.077,0,0,0-1.344-3.192A5.9,5.9,0,0,0,106.257,332.258Z",
    transform: "translate(-0.235 -0.19)",
    fill: "#41619a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_224",
    "data-name": "\\u30D1\\u30B9 224",
    d: "M106.454,345.128h-.136a1.462,1.462,0,0,0,0,2.924h.136a1.462,1.462,0,0,0,0-2.924Z",
    transform: "translate(-0.239 -0.337)",
    fill: "#41619a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatena);
export default __webpack_public_path__ + "static/media/hatena.9eb9ce0bd0090778378744334954cf39.svg";
export { ForwardRef as ReactComponent };